import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll window and any scrollable containers to top.
    const scrollToTop = () => {
      try {
        if (typeof window !== 'undefined' && window.scrollTo) {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        }

        const scEl = document.scrollingElement || document.documentElement || document.body;
        if (scEl) scEl.scrollTop = 0;

        // find other scrollable elements (overflow auto/scroll/overlay) and reset them
        const isScrollable = (el) => {
          const style = getComputedStyle(el);
          return /auto|scroll|overlay/.test(`${style.overflow}${style.overflowY}${style.overflowX}`);
        };

        const all = Array.from(document.querySelectorAll('*'));
        all.forEach((el) => {
          if (isScrollable(el)) el.scrollTop = 0;
        });
      } catch (e) {
        // swallow errors in environments where document/window aren't available
        // (keeps behavior safe during SSR)
        // console.warn('ScrollToTop error', e);
      }
    };

    // run after a short delay so newly mounted scroll containers exist
    const t = setTimeout(scrollToTop, 50);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
